<!-- 
  新建 发票管理的额外部分
  prop: 
    invoice: 发票信息
    express: 配送信息
    customerId: 客户id
    id: 编辑id
  三种业务场景
    新建：无 prop
    编辑: invoice, express, customerId, id
    业务流转: invoice, express, customerId
 -->

<template>
  <div class="add-invoice">
    <h3 class="title">发票信息</h3>
    <el-form ref="form" :model="invoiceData" label-width="120px">
      <el-form-item label="抬头类型">
        <el-select v-model="invoiceData.titleType">
          <el-option value="1" label="企业" key="1"></el-option>
          <el-option value="2" label="个人" key="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发票抬头">
        <el-input v-model="invoiceData.title"></el-input>
      </el-form-item>
      <el-form-item label="纳税识别号">
        <el-input v-model="invoiceData.taxpayerNo"></el-input>
      </el-form-item>
      <el-form-item label="注册电话">
        <el-input v-model="invoiceData.registeredPhone"></el-input>
      </el-form-item>
      <el-form-item label="开票地址">
        <el-input v-model="invoiceData.invoiceAddress"></el-input>
      </el-form-item>
      <el-form-item label="开户行">
        <el-input v-model="invoiceData.bank"></el-input>
      </el-form-item>
      <el-form-item label="开户账号">
        <el-input v-model="invoiceData.account"></el-input>
      </el-form-item>
      
    </el-form>
    <h3 class="title">
      <span class="name">寄送信息</span>
      <el-select v-model="address" value-key="id" @change="addressChoice" v-if="expressSelect.length" size="small">
        <el-option
          v-for="item in expressSelect"
          :value="item"
          :key="item.id"
          :label="item.name">
        </el-option>
      </el-select>
    </h3>
    <el-form ref="form" label-width="120px">
      <el-form-item label="地址名称">
        <el-input v-model="expressData.name"></el-input>
      </el-form-item>
      <el-form-item label="联系人">
        <el-input v-model="expressData.contact"></el-input>
      </el-form-item>
      <el-form-item label="联系电话">
        <el-input v-model="expressData.phone"></el-input>
      </el-form-item>
      <el-form-item label="详细地址">
        <v-address
          v-if="showAddress"
          @change="addressChange"
          module="invoice"
          :attrValue="expressData.addressJson">
        </v-address>
      </el-form-item>
      <el-form-item label="邮政编码">
        <el-input v-model="expressData.zipCode"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import * as api from 'src/api'
import vAddress from '../address'

let invoiceDefault = {
  titleType: '1',
  title: '',
  taxpayerNo: '',
  bank: '',
  account: '',
  invoiceAddress: '',
  registeredPhone: ''
}

let expressDefault = {
  name: '',
  contact: '',
  phone: '',
  addressJson: {},
  zipCode: ''
}

export default {
  props: ['customerId', 'invoice', 'express', 'id'],
  data () {
    return {
      invoiceData: Object.assign({}, invoiceDefault),
      expressData: Object.assign({}, expressDefault),
      expressSelect: [], // 地址下拉数据
      showAddress: true,
      address: ''
    }
  },
  created () {
    if (this.invoice) {
      this.invoiceData = this.invoice
      this.invoiceData.titleType = this.invoiceData.titleType ? this.invoiceData.titleType + '' : '1'
    }
    if (this.express) {
      this.expressData = this.express
    }
  },
  mounted () {
    // 业务流转
    if (this.customerId && this.customerId.id && !this.id) {
      this.getInvoice(this.customerId.id)
    }
    if (this.customerId && this.customerId.id && this.id) {
      this.getExpress(this.customerId.id)
    }
  },
  methods: {
    // 获取关联发票信息
    getInvoice (id) {
      this.showAddress = false
      let url = '/customerApi/getCustomerInvoiceExpressDetail.html'
      let params = {
        customerId: id
      }
      api.post(url, params, (data) => {
        let ci = data.customerInvoice
        this.invoiceData = ci.id ? ci : Object.assign({}, invoiceDefault)
        this.invoiceData.titleType = this.invoiceData.titleType ? this.invoiceData.titleType + '' : '1'
        this.expressSelect = data.customerExpress
        // 显示默认地址
        this.expressSelect.forEach(item => {
          if (item.isDefault) {
            this.address = item
            this.expressData = Object.assign({}, item)
            return
          }
        })

        this.showAddress = true
      })
    },

    // 只获取地址信息
    getExpress (id) {
      let url = '/customerApi/getCustomerInvoiceExpressDetail.html'
      let params = {
        customerId: id
      }
      api.post(url, params, (data) => {
        this.expressSelect = data.customerExpress
      })
    },
    // 监听地址变化
    addressChange (val) {
      this.expressData.addressJson = val
    },
    // 地址选择
    addressChoice (val) {
      this.expressData = Object.assign({}, val)
      this.showAddress = false
      this.$nextTick(() => {
        this.showAddress = true
      })
    }
  },
  components: {
    vAddress
  },
  watch: {
    // 监听客户ID的变化
    customerId: {
      handler (obj) {
        if (obj && obj.id) {
          this.getInvoice(obj.id)
        } else {
          this.invoiceData = Object.assign({}, invoiceDefault)
          this.expressData = Object.assign({}, expressDefault)

          // 通过开关地址，来清空地址数据
          this.showAddress = false
          this.$nextTick(() => {
            this.showAddress = true
          })
        }
      },
      deep: true
    }
  }
}
</script>
<style lang="less" scoped>
  @import '../../../assets/less/variable.less';
  .add-invoice {
    padding-right: 50px;
    .title {
      height: 24px;
      line-height: 24px;
      border-left: 4px solid @light-blue;
      color: @light-blue;
      padding-left: 12px;
      font-size: 15px;
      margin: 30px 0;
      .name {
        display: inline-block;
        vertical-align: top;
        width: 98px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// add-invoice.vue?dd5959a0